import { render, staticRenderFns } from "./AskLeave.vue?vue&type=template&id=b1ba2916&scoped=true&"
import script from "./AskLeave.vue?vue&type=script&lang=js&"
export * from "./AskLeave.vue?vue&type=script&lang=js&"
import style0 from "./AskLeave.vue?vue&type=style&index=0&id=b1ba2916&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ba2916",
  null
  
)

component.options.__file = "AskLeave.vue"
export default component.exports